import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
let _ = t => t,
  _t;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html, LitElement } from 'lit';
import FocusMixin from '@carbon/web-components/es/globals/mixins/focus.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from "././lightbox-media-viewer.css.js";
const {
  stablePrefix: c4dPrefix
} = settings;

/**
 * Media viewer modal body.
 */
class C4DLightboxMediaViewerBody extends FocusMixin(LitElement) {
  /**
   * @returns The description content.
   */

  /**
   * @returns The media content.
   */

  /**
   * @returns The title content.
   */

  render() {
    return html(_t || (_t = _`
      <div
        class="${0}--lightbox-media-viewer__container"
        part="container">
        <div class="${0}--lightbox-media-viewer__row" part="row">
          <div class="${0}--lightbox-media-viewer__media" part="media">
            ${0}
          </div>
          <div
            class="${0}--lightbox-media-viewer__media-description"
            part="content-wrapper">
            <div
              class="${0}--lightbox-media-viewer__content"
              part="content">
              <div
                part="title"
                class="${0}--lightbox-media-viewer__content__title"
                data-autoid="${0}--lightbox-media-viewer__content__title">
                ${0}
              </div>
              <div
                part="description"
                class="${0}--lightbox-media-viewer__content__desc"
                data-autoid="${0}--lightbox-media-viewer__content__desc">
                ${0}
              </div>
            </div>
          </div>
        </div>
      </div>
    `), c4dPrefix, c4dPrefix, c4dPrefix, this._renderMedia(), c4dPrefix, c4dPrefix, c4dPrefix, c4dPrefix, this._renderTitle(), c4dPrefix, c4dPrefix, this._renderDescription());
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
_defineProperty(C4DLightboxMediaViewerBody, "styles", styles);
export default C4DLightboxMediaViewerBody;
//# sourceMappingURL=lightbox-media-viewer-body.js.map
